{
  "defaultSiteUrl": "https://arkron.al",
  "defaultOgImage": "/assets/logo.png",
  "organization": {
    "name": "ARKRON",
    "sameAs": ["https://www.linkedin.com/company/arkron"],
    "contactType": "sales",
    "defaultEmail": "hello@arkron.al"
  },
  "fallbackServices": [
    {
      "id": "1",
      "title": "Web Development",
      "description": "High-performance web platforms built to scale, convert, and represent your brand with clarity.",
      "slug": "web-development",
      "icon": "web"
    },
    {
      "id": "2",
      "title": "Mobile App",
      "description": "Mobile experiences that are fast, intuitive, and refined across iOS and Android.",
      "slug": "mobile-app",
      "icon": "mobile"
    },
    {
      "id": "3",
      "title": "Creative Design (UI/UX)",
      "description": "Human-centered design systems that balance beauty, usability, and business outcomes.",
      "slug": "creative-design-uiux",
      "icon": "design"
    },
    {
      "id": "4",
      "title": "Consulting",
      "description": "Clear technical direction, execution planning, and decision support for leadership teams.",
      "slug": "consulting",
      "icon": "consulting"
    },
    {
      "id": "5",
      "title": "Maintenance and Support",
      "description": "Proactive care to keep your product secure, stable, and always improving.",
      "slug": "maintenance-and-support",
      "icon": "support"
    },
    {
      "id": "6",
      "title": "AI futuristic",
      "description": "Practical AI that automates workflows, unlocks insight, and delivers real ROI.",
      "slug": "ai-futuristic",
      "icon": "ai"
    },
    {
      "id": "7",
      "title": "Game Development",
      "description": "Game experiences and interactive systems designed for engagement, performance, and growth.",
      "slug": "game-development",
      "icon": "game"
    },
    {
      "id": "8",
      "title": "Original Products & Solutions",
      "description": "From concept to launch, we develop original digital products and tailored solutions with clear market fit.",
      "slug": "original-products-solutions",
      "icon": "product"
    }
  ],
  "copy": {
    "homeDescription": "ARKRON is a product engineering studio that builds web, mobile, AI, and digital systems for teams that care about clarity, speed, and long-term quality.",
    "notFoundTitle": "Page Not Found | ARKRON",
    "notFoundDescription": "The page you requested could not be found. Explore ARKRON services, technologies, and contact options from the main site.",
    "homeTitle": "ARKRON | Web, Mobile, AI, and Product Engineering",
    "servicesTitle": "Services | ARKRON",
    "servicesDescription": "Explore ARKRON services across web development, mobile apps, UI/UX design, consulting, AI integration, support, games, and custom products.",
    "serviceFallbackTitle": "Service",
    "serviceFallbackDescription": "Explore how ARKRON helps teams plan, build, and improve digital products with clear execution and durable engineering.",
    "ourWorkTitle": "Our Work | ARKRON",
    "ourWorkDescription": "See selected ARKRON work spanning product strategy, engineering execution, and measurable delivery outcomes.",
    "technologiesTitle": "Technologies | ARKRON",
    "technologiesDescription": "Discover the technologies ARKRON uses across mobile, frontend, backend, cloud, databases, product workflows, and DevOps.",
    "careerTitle": "Career | ARKRON",
    "careerDescription": "Join ARKRON to build serious, powerful software across web, mobile, AI, and product systems.",
    "aboutTitle": "About Us | ARKRON",
    "aboutDescription": "Learn about ARKRON, a product engineering studio helping ambitious teams turn strong ideas into reliable software.",
    "outsourcingKosovoTitle": "Software Outsourcing in Kosova | ARKRON",
    "outsourcingKosovoDescription": "ARKRON is a Kosova-based software outsourcing partner for US and European teams needing web, mobile, AI, and product engineering with reliable execution.",
    "contactTitle": "Contact Us | ARKRON",
    "contactDescription": "Contact ARKRON to discuss a website, mobile app, AI system, or product idea and get the right engineering support."
  }
}
